import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { getHeadingLevel } from 'lib/utils/getHeadingLevel';
import useExperienceEditor from 'lib/utils/use-experience-editor';
import { Foundation } from 'src/.generated/Foundation.EnterpriseWeb.model';
import { applySuperscripts } from 'src/helpers/Superscripts/superscript';
import { useTheme } from 'lib/context/ThemeContext';

export type SubheadlineProps = Foundation.EnterpriseWeb.Enterprise.FieldSets.Subheadline & {
  useTag?: string;
  classes: string;
};

const Subheadline = ({ fields, useTag, classes }: SubheadlineProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const { themeName } = useTheme();
  const isRbaTheme = themeName === 'rba';
  const defaultTag = 'h3';
  const tag = useTag ?? getHeadingLevel(defaultTag, fields?.subheadlineLevel);
  const raw = fields?.subheadlineText?.value ?? '';

  if (!raw && !isEE) {
    return <></>;
  }

  // RBA: process superscripts | AW: use raw text
  const valueToRender = isRbaTheme ? applySuperscripts(raw) : raw;
  const subheadlineField = { value: valueToRender };

  return (
    <div className={classNames('font-sans', classes)}>
      {isRbaTheme ? (
        <Text tag={tag} field={subheadlineField} encode={false} />
      ) : (
        <Text tag={tag} field={subheadlineField} />
      )}
    </div>
  );
};
export default Subheadline;
